import { rem } from "@certn/cascadia";
import { ActionListItem, Link, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  setting: string;
  value: string;
  description?: string;
  children?: React.ReactNode;
  expanded: boolean;
  testID?: string;
  editText?: string;
  toggle: () => void;
}

export function SettingsEditItem(props: Props) {
  const { t } = useTranslation();
  const {
    setting,
    value,
    description,
    expanded,
    toggle,
    children,
    testID,
    editText = t("Edit"),
  } = props;

  return (
    <>
      <ActionListItem
        displayAccessibility
        title={setting}
        trailing={
          <Link
            linkStyle="monochrome"
            textStyle="global/body-secondary"
            onPress={toggle}
            testID={testID || ""}
            aria-label={
              expanded
                ? t(`{{setting}} - Cancel`, { setting })
                : t(`{{setting}} - {{editText}}`, { setting, editText })
            }
          >
            {expanded ? <Trans>Cancel</Trans> : editText}
          </Link>
        }
      >
        <Text
          style="form/body-secondary"
          color="text-weak"
          className={css(
            expanded &&
              !description && {
                marginTop: 0,
              },
            expanded &&
              description && {
                marginTop: rem("space-4"),
              }
          )}
        >
          {!expanded ? value : description}
        </Text>
      </ActionListItem>
      {expanded && (
        <div
          className={css({
            paddingBottom: rem("space-4"),
            paddingLeft: rem("space-4"),
            paddingRight: rem("space-4"),
          })}
        >
          {children}
        </div>
      )}
    </>
  );
}
